import { useState, useEffect } from "react";
import { ORG_CONFIGURATION } from "../../../../../ApiServices/BaseURL";
import { postData } from "../../../../../ApiServices/ApiService";
import { convertGMTToLocal } from "../../../../../Utils/Validation";
import { useTheme } from "../../../../../GlobalContext/GlobalContext";
import { logFrontendException } from "../../../../../Utils/Exception";

const InvoiceSettingsConfigurationsController = (showServiceEstimateSeries, editServiceEstimateSeries, selectedServiceEstimate, showInvoiceSeries, editInvoiceSeries, selectedInvoiceSeries, showReceiptSeries, editReceiptSeries, selectedReceiptSeries, onRefresh) => {
    console.log("selectedServiceEstimate", selectedServiceEstimate)
    const [seriesType, setSeriesType] = useState("");
    const [seriesPrefix, setSeriesPrefix] = useState("");
    const [startDates, setStartDates] = useState("");
    const [endDates, setEndDates] = useState("");
    const { setIsLoginPopup } = useTheme();
    const [error, setError] = useState("");
    const [addLoading, setAddLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const [seriesTypeError, setSeriesTypeError] = useState("");
    const [seriesPrefixError, setSeriesPrefixError] = useState("");
    const [startDatesError, setStartDatesError] = useState("");
    const [endDatesError, setEndDatesError] = useState("");

    const pageName ="InvoiceSettingsConfigurationsController"
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

    useEffect(() => {
        if (editServiceEstimateSeries && selectedServiceEstimate) {
            setSeriesType(selectedServiceEstimate.series_type);
            setSeriesPrefix(selectedServiceEstimate.series_prefix);
            // setStartDates(selectedServiceEstimate.series_start_at);
            // setEndDates(selectedServiceEstimate.series_end_at);
            setStartDates(convertGMTToLocal(selectedServiceEstimate?.series_start_at,'yyyy-MM-dd'));
            setEndDates(convertGMTToLocal(selectedServiceEstimate?.series_end_at,'yyyy-MM-dd'));
        } else if (editInvoiceSeries && selectedInvoiceSeries) {
            setSeriesType(selectedInvoiceSeries.series_type);
            setSeriesPrefix(selectedInvoiceSeries.series_prefix);
            // setStartDates(selectedInvoiceSeries.series_start_at);
            // setEndDates(selectedInvoiceSeries.series_end_at);
            setStartDates(convertGMTToLocal(selectedInvoiceSeries?.series_start_at,'yyyy-MM-dd'));
            setEndDates(convertGMTToLocal(selectedInvoiceSeries?.series_end_at,'yyyy-MM-dd'));
        } else if (editReceiptSeries && selectedReceiptSeries) {
            setSeriesType(selectedReceiptSeries.series_type);
            setSeriesPrefix(selectedReceiptSeries.series_prefix);
            // setStartDates(selectedReceiptSeries.series_start_at);
            // setEndDates(selectedReceiptSeries.series_end_at);
            setStartDates(convertGMTToLocal(selectedReceiptSeries?.series_start_at,'yyyy-MM-dd'));
            setEndDates(convertGMTToLocal(selectedReceiptSeries?.series_end_at,'yyyy-MM-dd'));
        } else if (showServiceEstimateSeries || showInvoiceSeries || showReceiptSeries) {
            setSeriesType("");
            setSeriesPrefix("");
            setStartDates("");
            setEndDates("");
        }
        setSeriesTypeError('');
        setSeriesPrefixError('');
        setStartDatesError('');
        setEndDatesError('');
        setError('');
    }, [showServiceEstimateSeries, editServiceEstimateSeries, selectedServiceEstimate, showInvoiceSeries, editInvoiceSeries, selectedInvoiceSeries, showReceiptSeries, editReceiptSeries, selectedReceiptSeries]);

    const formatDateTime = (date) => {
        if (!date) return "";
        const d = new Date(date);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")} 00:00:00`;
    };


    const clearFeilds = () => {
        setSeriesType("");
        setSeriesPrefix("");
        setStartDates("");
        setEndDates("");
        setSeriesTypeError("");
        setSeriesPrefixError("");
        setStartDatesError("");
        setEndDatesError("");
        setError("");
    }


    const handleInvoice = async (action) => {

        try {
            setError('');
            setSuccessMessage('');
            setAddLoading(true);
            setSeriesTypeError('');
            setSeriesPrefixError('');
            setStartDatesError('');
            setEndDatesError('');

            // Validate Inputs
            if (!seriesType) {
                setSeriesTypeError("Please select the series type.");
                return;
            }

            if (seriesType === 3 && !seriesPrefix) {
                setSeriesPrefixError("Please fill the prefix.");
                return;
            }

            if (!startDates) {
                setStartDatesError("Please select the start date.");
                return;
            }

            if (!endDates) {
                setEndDatesError("Please select the end date.");
                return;
            }

            if (endDates < startDates) {
                setEndDatesError("End date can't be before start date");
                return;
            }

            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            const seriesId = selectedServiceEstimate?.series_id || selectedInvoiceSeries?.series_id || selectedReceiptSeries?.series_id;

            const payLoad = {
                "action": action,
                "emp_id_auth": storedUserInfo?.emp_id,
                "series_type": seriesType,
                "series_prefix": seriesPrefix,
                "series_start_at": formatDateTime(startDates),
                "series_end_at": formatDateTime(endDates),
                ...(seriesId && { "series_id": seriesId }),
            };

            console.log('catagory Data', payLoad);
            // Make the API call
            const response = await postData(ORG_CONFIGURATION, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setSuccessMessage(responseData?.info);
                        if (showServiceEstimateSeries || showInvoiceSeries || showReceiptSeries) {
                            clearFeilds();
                        }
                        setTimeout(() => {
                            setSuccessMessage('');
                            onRefresh();
                        }, 3000);
                    } else {
                        setError(responseData?.info || 'Failed to fetch data. Please try again.');
                        logFrontendException(storedUserId, pageName, "handleInvoice", responseData?.info || '');
                    }
                } else {
                    setError(responseData?.info || 'Something went wrong while processing your request.');
                    logFrontendException(storedUserId, pageName, "handleInvoice", responseData?.info || '');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "handleInvoice", response || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setError(responseData?.info || 'Bad request. Please check the request parameters.');
                    logFrontendException(storedUserId, pageName, "handleInvoice", response || '');
                }
                setIsLoginPopup(true)
            }
            // Internal Server Error: 500
           
            // Unexpected or network-related errors
            else {
                setError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "handleInvoice", response || '');
            }
        } catch (error) {
            // Handle various error scenarios
          
                setError(`Something went wrong while processing your request. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "handleInvoice-catch", error || '');
            
        } finally {
            setAddLoading(false);
        }
        // onValueChange(userData);
        // onClose();
    };

    return {
        seriesType,
        setSeriesType,
        seriesPrefix,
        setSeriesPrefix,
        startDates,
        setStartDates,
        endDates,
        setEndDates,
        error,
        successMessage,
        addLoading,
        handleInvoice,
        seriesTypeError,
        seriesPrefixError,
        startDatesError,
        endDatesError,
        clearFeilds,
    };
};

export default InvoiceSettingsConfigurationsController;
